import { z } from 'zod';

export const StorageLinkedQuoteItemSchema = z.object({
  persistent_id: z.string(),
  quote_id: z.number(),
  quote_code_number: z.string(),
  linked_revision_number: z.number(),
  linked_quote_item_name: z.string(),
});

export type StorageLinkedQuoteItem = z.infer<
  typeof StorageLinkedQuoteItemSchema
>;

export const StorageLinkedMouldingFlowSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type StorageLinkedMouldingFlow = z.infer<
  typeof StorageLinkedMouldingFlowSchema
>;

const StorageFileBaseSchema = z.object({
  id: z.number(),
  filename: z.string(),
  owner: z.string(),
  company: z.number().nullable(),
  company_name: z.string().nullable(),
  linked_quote_items: z.array(StorageLinkedQuoteItemSchema),
  can_delete: z.boolean(),
  delete_blocked_reason: z.string().nullable(),
});

export const CadStorageFileSchema = StorageFileBaseSchema.extend({
  for_moulding: z.boolean(),
  created_date: z.string(),
  linked_moulding_flows: z.array(StorageLinkedMouldingFlowSchema),
});

export type CadStorageFile = z.infer<typeof CadStorageFileSchema>;

export const CadStorageFileDetailSchema = CadStorageFileSchema.extend({
  file_url: z.string().nullable(),
  /** Top-level CAD objects for the 3D viewer. */
  cad_object_ids: z.array(z.number()),
});

export type CadStorageFileDetail = z.infer<typeof CadStorageFileDetailSchema>;

export const PaginatedCadStorageResponseSchema = z.object({
  count: z.number(),
  results: z.array(CadStorageFileSchema),
});

export type PaginatedCadStorageResponse = z.infer<
  typeof PaginatedCadStorageResponseSchema
>;

export const DrawingStorageFileSchema = StorageFileBaseSchema.extend({
  created_at: z.string(),
  /** Why the drawing can't be picked as an existing drawing, or null. */
  reuse_blocked_reason: z.string().nullable(),
});

export type DrawingStorageFile = z.infer<typeof DrawingStorageFileSchema>;

export const DrawingStorageFileDetailSchema = DrawingStorageFileSchema.extend({
  file_url: z.string().nullable(),
});

export type DrawingStorageFileDetail = z.infer<
  typeof DrawingStorageFileDetailSchema
>;

export const PaginatedDrawingStorageResponseSchema = z.object({
  count: z.number(),
  results: z.array(DrawingStorageFileSchema),
});

export type PaginatedDrawingStorageResponse = z.infer<
  typeof PaginatedDrawingStorageResponseSchema
>;

/** Splits off the extension, which the rename dialog keeps fixed. */
export function splitStorageFilename(filename: string): {
  stem: string;
  extension: string;
} {
  const dot = filename.lastIndexOf('.');
  return dot > 0
    ? { stem: filename.slice(0, dot), extension: filename.slice(dot) }
    : { stem: filename, extension: '' };
}
